import { IPrincipleItem } from "./types";
import { ReactComponent as TeamIcon } from "src/assets/icons/team-icon.svg";
import { ReactComponent as GlassIcon } from "src/assets/icons/glass-icon.svg";
import { ReactComponent as CalculatorIcon } from "src/assets/icons/calculator-icon.svg";
import { ReactComponent as CollaborationIcon } from "src/assets/icons/collaboration-white-icon.svg";
import { ReactComponent as MessageIcon } from "src/assets/icons/message-icon.svg";
import { ReactComponent as CupIcon } from "src/assets/icons/cup-icon.svg";

export const STAT_ITEMS = [
  { value: "9+", label: "Років на ринку" },
  { value: "1000+", label: "Задоволених клієнтів" },
  { value: "25+", label: "Років досвіду у кожного спеціаліста" },
];

export const PRINCIPLE_ITEMS: IPrincipleItem[] = [
  {
    id: "1",
    icon: TeamIcon,
    title: "Команда",
    description:
      "Ми створюємо умови, щоб кожен міг реалізувати свій потенціал, розвиватися та будувати кар’єру. Цінуємо ініціативу, креативність і сміливі рішення.",
  },
  {
    id: "2",
    icon: GlassIcon,
    title: "Відповідальність",
    description:
      "Ми є відповідальними за свої дії, за якість наданих нами послуг і дотримання усіх домовленостей або навпаки бездіяльність.",
  },
  {
    id: "3",
    icon: CalculatorIcon,
    title: "Професіоналізм",
    description:
      "Наша команда — це досвідчені фахівці, які постійно вдосконалюються та шукають нові шляхи для досягнення найкращих результатів.",
  },
  {
    id: "4",
    icon: CollaborationIcon,
    title: "Партнерство",
    description:
      "Завжди відкриті до співпраці, будуємо міцні зв'язки на основі чесності та професіоналізму.",
  },
  {
    id: "5",
    icon: MessageIcon,
    title: "Відкритість",
    description: "Ми відкриті до дискусій, спілкування і партнерства.",
  },
  {
    id: "6",
    icon: CupIcon,
    title: "Лідерство",
    description:
      "Ми йдемо на крок попереду, адаптуючись до змін та підтримуючи лідерські позиції.",
  },
];
